import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import {
  ForgotPasswordVerify,
  BackToLogin,
  ForgotPassword,
} from '../store/auth.actions';

@Component({
  selector: 'app-verify-forgot-password',
  templateUrl: './verify-forgot-password.component.html',
  styleUrls: ['./verify-forgot-password.component.scss']
})
export class VerifyForgotPasswordComponent implements OnInit {
  forgotPasswordVerifyForm: FormGroup;
  @Input() email;
  @Input() id;

  constructor(
    private fb: FormBuilder,
    public store: Store<AppState>,
  ) { }

  ngOnInit() {
    this.forgotPasswordVerifyForm = this.fb.group({
      email: [this.email, [Validators.required]],
      otp: ["", [Validators.required, Validators.minLength, Validators.maxLength]],
      mobileOtp: ["", [Validators.required, Validators.minLength, Validators.maxLength]]
    });
  }

  verifyOtp() {
    if (this.forgotPasswordVerifyForm.invalid) {
      return false;
    }
    this.store.dispatch(new ForgotPasswordVerify(this.forgotPasswordVerifyForm.value));
  }

  goBack() {
    this.store.dispatch(new BackToLogin())
  }

  resendOTP() {
    this.store.dispatch(new ForgotPassword(this.email));
  }
}
